import { Box, styled } from "@material-ui/core";
import { Title2 } from "components/design-system/atoms/Typography";
import Body from "components/design-system/atoms/Typography/Body";
import MaximumBonusAmount from "components/design-system/molecules/MaximumBonusAmount";
import QualiReparSvg from "./assets/qualirepar.svg";

const TurquoiseTitle2 = styled(Title2)(({ theme }) => ({
  color: theme.palette.turquoise.main,
  fontSize: 21,
  marginBottom: "10px",
  marginTop: theme.spacing(5),
}));

const BodyWithLineHeight = styled("p")(({ theme }) => ({
  lineHeight: "140%",
  marginBlockStart: theme.spacing(2),
  marginBlockEnd: theme.spacing(2),
}));

const StyledLink = styled("a")(({ theme }) => ({
  color: theme.palette.turquoise.main,
  textDecoration: "none",
}));

const DrawerWrapper = styled(Box)(({ theme }) => ({
  margin: `${theme.spacing(3)}px ${theme.spacing(1)}px ${theme.spacing(3)}px ${theme.spacing(1)}px`,
  [theme.breakpoints.down("md")]: {
    margin: `${theme.spacing(2)}px ${theme.spacing(1)}px ${theme.spacing(2)}px ${theme.spacing(1)}px`,
  },
}));

export default function RepairBonusDrawerContent() {
  return (
    <DrawerWrapper>
      <Box>
        <Body color="secondary" style={{ fontSize: "18px" }}>
          <Box mt="40px" style={{ textAlign: "center" }}>
            <QualiReparSvg />
          </Box>
          <TurquoiseTitle2>Qu&apos;est ce que le Bonus Réparation ?</TurquoiseTitle2>
          <BodyWithLineHeight style={{ marginTop: "10px" }}>
            Une aide pour inciter les français à réparer.
          </BodyWithLineHeight>
          <BodyWithLineHeight color="secondary">
            À chaque fois que vous achetez un appareil neuf, vous payez une petite éco-participation qui sert à financer
            cette aide à la réparation.
          </BodyWithLineHeight>
          <BodyWithLineHeight>
            Lancée le 15/12/22 sur les lave-linges, les lave-vaisselles, les sèche-linges, les fours encastrables et
            cuisinières, les réfrigérateurs, les congélateurs et les plaques de cuisson, entre 20 et{" "}
            <MaximumBonusAmount />€ par appareil réparé.
          </BodyWithLineHeight>

          <TurquoiseTitle2>Comment ça fonctionne ?</TurquoiseTitle2>
          <BodyWithLineHeight>
            Murfy s&#39;occupe des d&eacute;marches ! Si votre appareil est r&eacute;par&eacute; et remplit tous les
            crit&egrave;res ci-dessous, le montant de l&#39;aide sera <b>automatiquement d&eacute;duit</b> de votre
            forfait r&eacute;paration ou de votre pi&egrave;ce. <b>Pas besoin d&#39;avancer quoi que ce soit !</b>
          </BodyWithLineHeight>

          <BodyWithLineHeight>
            <StyledLink href="/landing/bonus-reparation-informations" target="_blank">
              Cliquez ici
            </StyledLink>{" "}
            pour pour plus d&apos;infos sur le fonctionnement de l&apos;aide.
          </BodyWithLineHeight>

          <TurquoiseTitle2>Dans quels cas le Bonus s&apos;applique-t-il ?</TurquoiseTitle2>
          <BodyWithLineHeight>
            Pour bénéficier du Bonus Réparation, nous avons besoin que certains critères soient remplis :
            <ul>
              <li>votre appareil doit avoir été réparé par notre réparateur,</li>
              <li>Il ne doit pas être sous garantie au moment de la réparation,</li>
              <li>Il doit appartenir à une marque éligible à cette aide,</li>
              <li>Il doit avoir une plaque signalétique bien visible,</li>
              <li>Vous devez être un particulier et non une entreprise.</li>
            </ul>
            <StyledLink href="/landing/bonus-reparation-informations" target="_blank">
              Cliquez ici
            </StyledLink>{" "}
            pour retrouver l’ensemble des critères.
          </BodyWithLineHeight>
        </Body>
      </Box>
    </DrawerWrapper>
  );
}
